import { render, staticRenderFns } from "./bi-tooltip.vue?vue&type=template&id=690d7a33&"
import script from "./bi-tooltip.vue?vue&type=script&lang=ts&"
export * from "./bi-tooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports